import { BaseEntity } from "app/core";

export class InsuredNote extends BaseEntity {
    fecNota: Date;
    nota: string;
    titulo: string;
    codAseg: number;
    idDocumento: number;
    numero: number;
    entidadId: number;
    userId: number;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/InsuredNote.ts